import { Tooltip } from '@mui/material';
import { SVG } from 'components/Asset/SVG';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface Props {
  bumperNumber: string;
  isActive: boolean;
}

export function AssetDTCNotifications({ bumperNumber, isActive }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleDTCClick = () => {
    navigate('/diagnostic-trouble-codes', {
      state: {
        bumperNumber,
        isActive,
      },
    });
  };

  return (
    <Tooltip title={t('asset_has_dtc_notifications')} placement="bottom" arrow>
      <div
        style={{
          cursor: 'pointer',
          position: 'absolute',
          top: '5px',
          right: '5px',
        }}
      >
        <SVG
          name="dTCIcon"
          style={{
            fill: '#EB5757',
            height: '1.3em',
            width: '1.1em',
            cursor: 'pointer',
          }}
          onClick={handleDTCClick}
        />
      </div>
    </Tooltip>
  );
}

export default AssetDTCNotifications;
